// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"73":"7981a0e7","736":"4bbe0eb7","980":"784f0fc1"}[chunkId] + ".css";
};